<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12">
                <b-button v-on:click="goBack" variant="secondary">
                    <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <h1>Move/Copy Templates</h1>
            </b-col>
        </b-row>
        <div v-if="sourceSelectionMode" class="viewMode">
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Source Templates</strong>
                        </div>                        
                        <TemplateListSelectionCopy v-on:templates-selected="templatesSelected" :current-selected="selectedTemplates" />
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="targetSelectionMode" class="viewMode">
            <TemplateTargetSelection :current-selected="selectedTemplates" v-on:target-selected="templatesTargetSelected" />
        </div>
        <div v-if="committingDataMode" class="viewMode">
            <h4>Working...</h4>
            <b-progress :value="dataCommitProgress" :max="dataCommitMax" show-progress animated class="mb-3"></b-progress>
        </div>
        <div v-if="commitComplete" class="viewMode">
            <b-alert variant="success" show><strong>Complete</strong></b-alert>
        </div>
        
    </div>
</template>

<script>

import TemplateListSelectionCopy from '../../components/data-control/templates/TemplateListSelectionCopy.vue';
import TemplateTargetSelection from '../../components/data-control/templates/TemplateTargetSelection.vue';
import TemplatesService from '@/services/templates-service.js';

export default {
  name: 'templates',
  components: {
      TemplateListSelectionCopy: TemplateListSelectionCopy,
      TemplateTargetSelection: TemplateTargetSelection
  },
  data () {
    return {
        sourceSelectionMode: true,
        targetSelectionMode: false,
        committingDataMode: false,
        dataCommitProgress: 0,
        dataCommitMax: 0,
        selectedTemplates: [],
        commitComplete: false
    }
  },
  methods: {
    goBack() {
        if (this.$data.targetSelectionMode) {
            this.$data.targetSelectionMode = false;
            this.$data.sourceSelectionMode = true;
        }
        else {
            this.$router.push('/data-control');
        }
        
    },
    templatesSelected(templates) {
        this.$data.selectedTemplates = templates;
        this.$data.targetSelectionMode = true;
        this.$data.sourceSelectionMode = false;
    },
    async templatesTargetSelected(targetParams) {
        // everything has been chosen, so now post the templates to their new home if being moved, or create new ones if being copied

        // So, if the template is being moved, send an 'update'
        // if the template is being copied, send a 'create'
        this.$data.committingDataMode = true;
        this.$data.dataCommitMax = this.$data.selectedTemplates.length;

        this.$data.dataCommitProgress = 0;
        for (let templateNumber = 1; templateNumber <= this.$data.selectedTemplates.length; templateNumber++) {
            let templateToSend = JSON.parse(JSON.stringify(this.$data.selectedTemplates[templateNumber - 1]));
            // update the company, area and site id's
            templateToSend.company_id = targetParams.company_id;
            templateToSend.area_id = targetParams.area_id;
            templateToSend.site_id = targetParams.site_id;

            // get rid of parts of the template we don't want to pass to the API
            delete templateToSend.area;
            delete templateToSend.supplier;
            delete templateToSend.action;
            delete templateToSend.copyRequested;
            delete templateToSend.moveRequested;
            delete templateToSend.area_name;
            delete templateToSend.plate_size;
            delete templateToSend.supplier_name;
            delete templateToSend.is_default_text;

            if (this.$data.selectedTemplates[templateNumber - 1].moveRequested) {
                // send an 'update'
                // create the object with just the fields that need to update
                const movingTemplate = {
                    company_id: targetParams.company_id,
                    area_id: targetParams.area_id,
                    site_id: targetParams.site_id,
                    registration_number: ''
                };
                await TemplatesService.updateTemplate(movingTemplate, templateToSend.id);
                this.$data.dataCommitProgress++;
            }
            else {
                // send a 'create'
                // remove the id first or the create will fail
                delete templateToSend.id;
                await TemplatesService.createTemplate(templateToSend);
                this.$data.dataCommitProgress++;
            }
        };

        // flag the process as complete
        setTimeout(() => {
            this.$data.committingDataMode = false;
            this.$data.commitComplete = true;
        }, 1000);
        setTimeout(() => {
            this.$router.push('/data-control');
        }, 3000);

        // now we're done, go back
        //this.$router.push('/data-control');
    }
  }
}
</script>
